import React, { useContext } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import CrmPostventaV2AlertsBoard from "./CrmPostventaV2AlertsBoard";

export default function CrmPostventaAlertasV2Page() {
  const { darkMode } = useContext(DarkModeContext);

  return <CrmPostventaV2AlertsBoard darkMode={darkMode} />;
}
